import { call, put, takeLeading } from "redux-saga/effects";
import moment from "moment";
import { formatDecimal, formatPrice } from "../../utils/formatNumber";

import { getPricesSuccess, getPricesFailure } from "./Prices.actions";
import { PricesService } from "./Prices.store";

function* getPricesSaga(args) {
  try {
    const pricesService = new PricesService();
    const { data, page, pageSize, results: total } = yield call(
      pricesService.fetchPrices,
      args.params
    );

    const prices = data.map((item) => {
      const currentBlock = Math.floor(moment().unix() / 3600);
      return {
        block: item.block,
        date: moment(item.date).format("L LT"),
        status:
          item.block === 432559
            ? "100x split"
            : item.block <= currentBlock
            ? item.block === currentBlock
              ? "active"
              : "completed"
            : "confirmed",
        price: formatPrice(formatDecimal(item.risePrice)),
      };
    });

    const { direction } = args.params;
    yield put(getPricesSuccess(prices, direction, page, pageSize, total));
  } catch (error) {
    yield put(getPricesFailure(error));
  }
}

export function* pricesSagas() {
  const GET_PRICES = "GET_PRICES";
  yield takeLeading(GET_PRICES, getPricesSaga);
}
